import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import { Add, FilterAlt } from "@mui/icons-material"
import MaterialButton from "../../../components/MaterialButton"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import { useEffect, useState } from "react"
import Table from "../../../components/Table"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";
import WorkflowBindingFilterDialog from './components/WorkflowBindingFilterDialog.js';

const WorkflowBindingList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.operationWorkflowBindingStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.operationWorkflowBindingStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.operationWorkflowBindingStore?.totalPages);

    const [workflowBindingData, setWorkflowBindingData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        workflowStepId: "",
        bindingId: "",
        bindingTypeId: "",
        environmentId: ""
    });

    useEffect(() => {
        fetchWorkflowBindingList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchWorkflowBindingList = async () => {
        setCircleLoading(true);
        try {     
        let url = `/orchestration/workflow-binding?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`
        if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.workflowStepId !== "" && filterData.workflowStepId !== null && filterData.workflowStepId !== undefined) {
            url += `&workflowStepId=${filterData.workflowStepId}`;
        }
        if(filterData.bindingIdbindingTypeId !== "" && filterData.bindingIdbindingTypeId !== null && filterData.bindingIdbindingTypeId !== undefined) {
            url += `&bindingIdbindingTypeId=${filterData.bindingIdbindingTypeId}`;
        }
        if(filterData.bindingTypeId !== "" && filterData.bindingTypeId !== null && filterData.bindingTypeId !== undefined) {
            url += `&bindingTypeId=${filterData.bindingTypeId}`;
        }
        if(filterData.environmentId !== "" && filterData.environmentId !== null && filterData.environmentId !== undefined) {
            url += `&environmentId=${filterData.environmentId}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setWorkflowBindingData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Workflow List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Insurer Api List:', error);
            showSnackbar(error?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/orchestration/workflow-binding-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Error deleting Insurer Registry data", "error");
        }
    };

    //table mapping
    const workflowBindingTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },            
            { key: "workflowStep", label: "Workflow Step", renderCell: (row) => row.workflowStep },
            { key: "bindingType", label: "Binding Type", renderCell: (row) => row.bindingType },
            { key: "createdAt", label: "Created At", renderCell: (row) => row.createdAt },
            {
            key: "isActive",
            label: "Status",
            renderCell: (row) => (
                <span>
                {row.isActive ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                )}
                </span>
            )
            },
        ],
        rows: workflowBindingData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            workflowStep: item?.workflowStep?.stepName || "",
            bindingType: item?.bindingType?.keyName || "",
            createdAt: new Date(item?.createdAt).toLocaleDateString('en-GB'),
            isActive: item?.isActive
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/operation/workflow-binding/workflow-binding-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/operation/workflow-binding/workflow-binding-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Workflow Binding List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Workflow Binding.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt />}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/operation/workflow-binding/workflow-binding-details')}
                    >
                        Workflow Binding
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
          <Table
          columns={workflowBindingTable?.columns}
          data={workflowBindingTable?.rows}
          actions={actions}
          pagination={{
              totalPages,
              currentPage,
              onPageChange: (page) => handlePaginationChange(page),
              rowsPerPage,
              onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
              rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Workflow Binding Data found"
          handleSearch={handleSearch}
          />
        </CardContent>
        <WorkflowBindingFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);
            fetchWorkflowBindingList();
        }}
        />
    </DashboardLayout>
  )
}

export default WorkflowBindingList